"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiUnlockAll = /** @class */ (function (_super) {
    __extends(ApiUnlockAll, _super);
    function ApiUnlockAll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.CREATE_UNLOCK_ALL_ITEM = '/api/unlockAllDiscount/create';
        _this.GET_UNLOCK_ALL_DISCOUNT = '/api/unlockAllDiscount/viewBasic/basic';
        _this.GET_UNLOCK_ALL_LIST = '/api/unlockAllDiscount/list';
        _this.GET_UNLOCK_ALL_ITEM = '/api/unlockAllDiscount/view';
        _this.UPDATE_UNLOCK_ALL_DISCOUNT = '/api/unlockAllDiscount/updateBasic';
        _this.UPDATE_UNLOCK_ALL_ITEM = '/api/unlockAllDiscount/update';
        _this.DELETE_UNLOCK_ALL_ITEM = '/api/unlockAllDiscount/delete';
        /**
         * 전체소장 할인 상세페이지
         * @param accessToken
         */
        _this.getUnlockAllDiscount = function (accesstoken) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.GET_UNLOCK_ALL_DISCOUNT,
            });
        };
        /**
         * 개별 할인 리스트
         * @param accessToken
         * @param language
         * @param discountType : singleComic(현재는 해당키만 사용)
         * @param page
         * @param limit (추후 성능이슈 발생시 paging구현 기본값으로 10000으로 set)
         * @return {Promise<unknown>}
         */
        _this.getUnlockAllDiscountList = function (accesstoken, discountType, req) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: "".concat(_this.GET_UNLOCK_ALL_LIST, "/").concat(discountType),
                data: req,
            });
        };
        /**
         * 개별 할인 아이템 정보
         * @param accessToken
         * @param id
         * @return {Promise | Promise<unknown>}
         */
        _this.getUnlockAllDisCountItem = function (accesstoken, id) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: "".concat(_this.GET_UNLOCK_ALL_ITEM, "/").concat(id),
            });
        };
        /**
         * 개별 할인 아이템 등록
         * @param accessToken
         * @param request
         * @return {Promise | Promise<unknown>}
         */
        _this.createUnlockAllDiscountItem = function (accesstoken, req) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.CREATE_UNLOCK_ALL_ITEM,
                data: req,
            });
        };
        /**
         * 전체소장 할인 상세페이지 정보 업데이트
         * @param accessToken
         * @param request
         * @return {Promise | Promise<unknown>}
         */
        _this.updateUnlockAllDiscount = function (accesstoken, req) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.UPDATE_UNLOCK_ALL_DISCOUNT,
                data: req,
            });
        };
        /**
         * 개별 할인 아이템 업데이트
         * @param accessToken
         * @param request
         * @return {Promise | Promise<unknown>}
         */
        _this.updateUnlockDisCountItem = function (accesstoken, req) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.UPDATE_UNLOCK_ALL_ITEM,
                data: req,
            });
        };
        /**
         * 개별 할인 아이템 삭제
         * @param accessToken
         * @param id
         * @return {Promise<unknown>}
         */
        _this.deleteUnlockDisCountItem = function (accesstoken, id) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: "".concat(_this.DELETE_UNLOCK_ALL_ITEM, "/").concat(id),
            });
        };
        return _this;
    }
    ApiUnlockAll.getInstance = function (initValue) {
        if (!ApiUnlockAll.classInstance) {
            this.classInstance = new ApiUnlockAll(initValue);
        }
        return this.classInstance;
    };
    return ApiUnlockAll;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiUnlockAll;
